import type { ComponentSingleStyleConfig } from "@chakra-ui/react";
const Button: ComponentSingleStyleConfig = {
  baseStyle: {
    height: { sm: "40px", lg: "32px", xl: "40px" },
    px: "16px",
    borderRadius: "full",
    _focus: {
      boxShadow: "0px",
    },
		_disabled: {
			cursor: "not-allowed",
			opacity: ".4",
		},
  },
  defaultProps: {
    variant: "solid",
  },
  sizes: {
    lg: {
      fontSize: "lg",
      fontWeight: "medium",
      lineHeight: "20px",
    },
    lg_light: {
      fontSize: "lg",
      fontWeight: "light",
      lineHeight: "20px",
    },
    large: {
      fontSize: { sm: "lg", lg: "md", xl: "lg" },
      fontWeight: { sm: "medium", lg: "normal", xl: "medium" },
      lineHeight: "20px",
    },
    filter_pill: {
      h: "36px",
      minW: "96px",
      w: "96px",
      px: "12px",
      fontSize: "sm",
      fontWeight: "medium",
      lineHeight: "16px",
    },
  },
  variants: {
    solid: {
      bg: "var(--clr1)",
      color: "white",
      _hover: {
        bg: "var(--clr1)",
        opacity: 0.92,
      },
    },
    outline: {
      bg: "#fff !important",
      color: "var(--clr1) !important",
      border: "1px solid",
      borderColor: "var(--clr1)",
      _hover: {
        bg: "var(--clr1) !important",
        color: "white !important",
        borderColor: "var(--clr1)",
        _disabled: {
          bg: "#fff !important",
          color: "var(--clr1) !important",
        },
      },
      _disabled: {
        opacity: 1,
        bg: "#fff !important",
        color: "#A19F9D !important",
        borderColor: "#D2D0CE",
        cursor: "not-allowed",
      },
    },
    ghost: {
      bg: "transparent",
      color: "var(--clr1)",
      border: "none",
      _hover: {
        bg: "grey.10",
        color: "var(--clr1)",
      },
      _active: {
        bg: "grey.50",
        color: "var(--clr1)",
      },
    },
    solidBlue: {
      bg: "var(--clr1)",
      color: "white",
      borderRadius: "full",
    },
    solid_lightBlue: {
      bg: "var(--clr1)",
      color: "white",
      borderRadius: "full",
      _hover: {
        _disabled: {
          bg: 'var(--clr1)',
          opacity: "0.7",
        },
      },
      _disabled: {
        opacity: "0.7",
      },
    },
    Solid_gray: {
      bg: "#FAF9F8",
      border: "1px",
      borderColor: "#A19F9D",
      borderRadius: "full",
      color: "#605E5C",
      _hover: {
        bg: "var(--clr1)",
        borderColor: "var(--clr1)",
        color: "white",
        "& h4, & svg": {
          color: "white !important",
        },
      },
    },
    Solid_disabled: {
      bg: "#EDEBE9",
      color: "#A19F9D",
    },
    Solid_outline: {
      bg: "#fff !important",
      color: "#A00F0F",
      border: "1px solid",
      borderColor: "#A00F0F",
      transition: "0.1s ease-out",
    },
    Solid_outline_primary: {
      bg: "#fff !important",
      color: "var(--clr1) !important",
      border: "1px solid",
      borderColor: "var(--clr1)",
      _hover: {
        bg: "var(--clr1) !important",
        borderColor: "var(--clr1)",
        color: "white !important",
        transition: "0.1s ease-in",
        "& h4, & svg": {
          color: "white !important",
        },
      },
    },
    Solid_red: {
      bg: "#ffd1df",
      color: "#c2185c",
      border: "1px solid",
      borderColor: 'var(--clr1)',
      _hover: {
        bg: "#c2185c",
        color: "white",
        transition: "0.1s ease-in",
      },
    },
    Solid_red_error: {
      bg: "#ff0000",
      color: "#fff",
      border: "1px solid",
      borderColor: "#ff0000",
      _hover: {
        bg: "#ff0000",
        color: "white",
        transition: "0.1s ease-in",
      },
    },
    rounded_edges: {
      bg: 'var(--clr1)',
      borderRadius: "full",
    },
    transparent: {
      bg: "transparent",
      color: "black",
      fontSize: "sm",
      fontWeight: "bold",
      transition: "0.1s ease",
      _hover: {
        color: "green.500",
        transition: "0.1s ease",
      },
    },
    boxShadow: {
      boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
      borderRadius: "8px",
      bg: "white.900",
      color: "black.900",
      _disabled: {
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
      },
    },
    link: {
      bg: "transparent",
      color: "var(--clr1)",
      border: "none",
      borderRadius: "0",
      h: "auto",
      minH: "auto",
      px: 0,
      py: 0,
      fontWeight: "600",
      _hover: {
        bg: "transparent",
        color: "var(--clr1)",
        textDecoration: "underline",
      },
      _active: {
        bg: "transparent",
        color: "var(--clr1)",
      },
    },
  },
};

export default Button;
